import { render, staticRenderFns } from "./AboutPageContent.vue?vue&type=template&id=4f31ec9d"
import script from "./AboutPageContent.vue?vue&type=script&lang=js"
export * from "./AboutPageContent.vue?vue&type=script&lang=js"
import style0 from "./AboutPageContent.vue?vue&type=style&index=0&id=4f31ec9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports